module.exports = __webpack_public_path__ + "img/img-13.b49b85fc.webp";